import AbstractManageable from './abstract-manageable';
import Account            from './account';
import LocalAuthority     from './local-authority';
import User               from './user';

export default class Observation extends AbstractManageable {

	/**
	 * 
	 * @param {number}         id 
	 * @param {LocalAuthority} localAuthority 
	 * @param {Account}        account 
	 * @param {number}         amount 
	 * @param {boolean}        receipts 
	 * @param {number}         year 
	 * @param {User}           creator 
	 * @param {Date}           createdAt 
	 * @param {User}           updater 
	 * @param {Date}           updatedAt 
	 */
	constructor(
			id,
			localAuthority,
			account,
			amount,
			receipts,
			year,
			creator,
			createdAt,
			updater,
			updatedAt) {
		super(creator, createdAt, updater, updatedAt);

		this.account        = account;
		this.amount         = amount;
		this.id             = id;
		this.localAuthority = localAuthority;
		this.receipts       = receipts;
		this.year           = year;
	}

	static createFromJson = (json) => {
		if (!json) return null;

		return new Observation(
			json.id,
			LocalAuthority.createFromJson(json.localAuthority),
			Account.createFromJson(json.account),
			json.amount,
			json.receipts,
			json.year,
			User.createFromJson(json.creator),
			new Date(json.createdAt),
			User.createFromJson(json.updater),
			new Date(json.updatedAt)
		);
	}
}


// WEBPACK FOOTER //
// ./src/model/observation.js